module.exports = __webpack_public_path__ + "static/media/defaultVenueIcon.006ed5be.svg";